import { Theme, Typography } from '@mui/material'
import { CSSProperties, ReactNode } from 'react'
import { FieldPath, FieldValues, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

type Props<Schema extends FieldValues> = {
  path: FieldPath<Schema>
}

const SAFE_MINIMUM: number = 4_000 // [ms]

export const SingleAdViewTimeSoftValidator = <Schema extends FieldValues>({
  path,
}: Props<Schema>): ReactNode => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.multiAnchor.basicSettings.columns.singleAdViewTime',
  })
  const value: number | undefined = useWatch<Schema>({ name: path })

  if (value === undefined || value >= SAFE_MINIMUM) {
    return undefined
  }

  return (
    <Typography
      component='span'
      sx={(theme: Theme): CSSProperties => ({ color: theme.palette.warning.main })}
      variant='caption'
    >
      {t('recommendedMinimum')}
    </Typography>
  )
}
